import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteBlogsApi, getAllBlogsApi, IMG_URL } from "../helper/api_helper";
import { Icon } from "@iconify/react/dist/iconify.js";
const BlogLayer = () => {
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [blogData, setBlogData] = useState([]);
  const getAllBlogs = async () => {
    try {
      setIsPageLoading(true);
      const response = await getAllBlogsApi();
      console.log("RESPONSE ::", response.data.blogs);

      setBlogData(response.data.blogs);
    } catch (error) {
      toast.error("Failed to fetch blogs");
      setBlogData([]);
    } finally {
      setIsPageLoading(false);
    }
  };

  useEffect(() => {
    getAllBlogs();
  }, []);

  const [selectedBlogId, setSelectedBlogId] = useState(null);
  const handleConfirmDelete = async () => {
    if (!selectedBlogId) return;
    try {
      const data = await deleteBlogsApi({ id: selectedBlogId });
      getAllBlogs();
      const modalEl = document.getElementById("exampleModalEdit");
      const modalBackdrop = document.querySelector(".modal-backdrop");

      modalEl.classList.remove("show");
      modalEl.style.display = "none";
      modalEl.setAttribute("aria-hidden", "true");

      if (modalBackdrop) modalBackdrop.remove();
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    } catch (err) {
      console.error("Fetch Error:", err);

      toast.error(err || "Something went wrong");
    } finally {
    }
  };

  return (
    <>
      <div className="row gy-4">
        {blogData.map((item) => (
          <div className="col-xxl-3 col-lg-4 col-sm-6" key={item.id}>
            <div className="card h-100 p-0 radius-12 overflow-hidden">
              <div className="card-body p-24">
                <Link
                  className="w-100 radius-8 overflow-hidden"
                  style={{ height: "180px", position: "relative" }}
                >
                  <div className="dropdown position-absolute top-0 end-0 me-16 mt-16">
                    <button
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      className="bg-white-gradient-light text-primary-600 w-32-px h-32-px radius-8 border border-primary-light-white d-flex justify-content-center align-items-center text-white"
                    >
                      <Icon
                        icon="entypo:dots-three-vertical"
                        className="icon "
                      />
                    </button>
                    <ul className="dropdown-menu p-12 border bg-base shadow">
                      <li>
                        <Link
                          to={`/edit-blog?id=${item.id}`}
                          className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 d-flex align-items-center gap-10"
                        >
                          Edit
                        </Link>
                      </li>
                      <li>
                        <button
                          onClick={() => setSelectedBlogId(item.id)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModalEdit"
                          type="button"
                          className="delete-btn dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-danger-100 text-hover-danger-600 d-flex align-items-center gap-10"
                        >
                          Delete
                        </button>
                      </li>
                    </ul>
                  </div>
                  <img
                    src={`${IMG_URL}/${item.image}`}
                    alt={item.title}
                    className="w-100 h-100 object-fit-cover"
                  />
                </Link>
                <div className="mt-20">
                  <div className="d-flex align-items-center gap-6 justify-content-between flex-wrap mb-16">
                    <Link className="px-20 py-6 bg-neutral-100 rounded-pill bg-hover-neutral-300 text-neutral-600 fw-medium">
                      {item.blogCategory?.categoryName || "Uncategorized"}
                    </Link>
                    <div className="d-flex align-items-center gap-8 text-neutral-500 fw-medium">
                      <i className="ri-calendar-2-line" />
                      {new Date(item.createdAt).toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                      })}
                    </div>
                  </div>
                  <h6 className="mb-16">
                    <Link className="text-line-2 text-hover-primary-600 text-xl transition-2">
                      {item.title}
                    </Link>
                  </h6>
                  {/* <div
                    className="text-line-3 text-neutral-500"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  /> */}
                  {/* <Link
                    to={`/blog-details?id=${item.id}`}
                    className="d-flex align-items-center gap-8 fw-semibold text-neutral-900 text-hover-primary-600 transition-2"
                  >
                    Read More
                    <i className="ri-arrow-right-double-line text-xl d-flex line-height-1" />
                  </Link> */}
                  <div
                    className="text-line-3 text-neutral-500"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />

                  <Link
                    to={
                      item.scheduledDate &&
                      new Date(item.scheduledDate) > new Date()
                        ? "#" // disable if future
                        : `https://www.sshealthconnect.com/blog?id=${item.id}`
                    }
                    target="_blank"
                    onClick={(e) => {
                      if (
                        item.scheduledDate &&
                        new Date(item.scheduledDate) > new Date()
                      ) {
                        e.preventDefault(); // block click for future date
                      }
                    }}
                    className={`d-flex align-items-center gap-8 fw-semibold text-neutral-900 transition-2 ${
                      item.scheduledDate &&
                      new Date(item.scheduledDate) > new Date()
                        ? "text-muted cursor-not-allowed opacity-50"
                        : "text-hover-primary-600"
                    }`}
                    style={
                      item.scheduledDate &&
                      new Date(item.scheduledDate) > new Date()
                        ? { pointerEvents: "none" }
                        : {}
                    }
                  >
                    {(() => {
                      if (!item.scheduledDate) return "Read More";

                      const scheduled = new Date(item.scheduledDate);
                      const now = new Date();

                      if (scheduled < now) return "Read More";

                      // Format date as dd/mm/yyyy
                      const formattedDate = `${String(
                        scheduled.getDate()
                      ).padStart(2, "0")}/${String(
                        scheduled.getMonth() + 1
                      ).padStart(2, "0")}/${scheduled.getFullYear()}`;

                      return formattedDate;
                    })()}

                    <i className="ri-arrow-right-double-line text-xl d-flex line-height-1" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div
        className="modal fade"
        id="exampleModalEdit"
        tabIndex={-1}
        aria-labelledby="exampleModalEditLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
              <h1 className="modal-title fs-5" id="exampleModalEditLabel">
                Confirm Deletion
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body p-24 text-center">
              <p className="mb-4 fs-6 text-secondary">
                Are you sure you want to delete blog?
              </p>
              <div className="d-flex justify-content-center gap-3 mt-3">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleConfirmDelete}
                >
                  Confirm
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default BlogLayer;
